export const PROGRAMME_CATEGORIES = [
  "Masterclass",
  "Executive Programme",
  "Certification Programme",
  "Corporate Programme",
  "Workshop",
  "Micro-Learning",
  "Learning Journey",
];

export const PROGRAMMES = [
  {
    slug: "strategic-thinking-for-senior-leaders",
    title: "Strategic Thinking for Senior Leaders",
    category: "Executive Programme",
    capability: "Strategy",
    audience: "Business Leaders",
    format: "Cohort",
    duration: "6 weeks",
    summary: "A structured programme on seeing the whole board — industry dynamics, competitive position and the choices that create advantage.",
    featured: true,
  },
  {
    slug: "the-executive-leadership-masterclass",
    title: "The Executive Leadership Masterclass",
    category: "Masterclass",
    capability: "Leadership",
    audience: "Business Leaders",
    format: "In-person",
    duration: "2 days",
    summary: "An intensive masterclass on executive judgement, leading through others and setting the conditions for performance.",
    featured: true,
  },
  {
    slug: "first-principles-thinking-from-the-ground-up",
    title: "First Principles: Thinking From the Ground Up",
    category: "Workshop",
    capability: "Strategy",
    audience: "Founders",
    format: "In-person",
    duration: "1 day",
    summary: "A working session on stripping problems to their fundamentals and rebuilding solutions without inherited assumptions.",
    featured: false,
  },
  {
    slug: "sales-and-commercial-excellence-programme",
    title: "Sales & Commercial Excellence Programme",
    category: "Certification Programme",
    capability: "Sales & Commercial Excellence",
    audience: "Sales Professionals",
    format: "Blended",
    duration: "8 weeks",
    summary: "Commercial thinking, customer value creation and disciplined pipeline execution for professional sellers and sales leaders.",
    featured: true,
  },
  {
    slug: "manager-effectiveness-journey",
    title: "The Manager Effectiveness Journey",
    category: "Learning Journey",
    capability: "People & Organisation",
    audience: "Managers",
    format: "Blended",
    duration: "12 weeks",
    summary: "A guided journey that builds the core disciplines of managing: clarity, coaching, accountability and execution through people.",
    featured: false,
  },
  {
    slug: "building-the-customer-centric-organisation",
    title: "Building the Customer-Centric Organisation",
    category: "Corporate Programme",
    capability: "Customer",
    audience: "Organisations",
    format: "Custom",
    duration: "Custom",
    summary: "A corporate programme that embeds customer thinking into strategy, operations and everyday decision-making.",
    featured: false,
  },
  {
    slug: "digital-and-ai-fluency-for-executives",
    title: "Digital & AI Fluency for Executives",
    category: "Executive Programme",
    capability: "Digital & AI",
    audience: "Business Leaders",
    format: "Cohort",
    duration: "4 weeks",
    summary: "Executive-level fluency in digital transformation and applied AI — what to invest in, what to question and how to lead it.",
    featured: true,
  },
  {
    slug: "entrepreneurial-thinking-intensive",
    title: "The Entrepreneurial Thinking Intensive",
    category: "Workshop",
    capability: "Business & Entrepreneurship",
    audience: "Entrepreneurs",
    format: "In-person",
    duration: "3 days",
    summary: "An intensive for entrepreneurs on opportunity evaluation, business model design and the discipline of building to last.",
    featured: false,
  },
  {
    slug: "executive-decision-making-under-uncertainty",
    title: "Executive Decision-Making Under Uncertainty",
    category: "Masterclass",
    capability: "Leadership",
    audience: "Business Leaders",
    format: "In-person",
    duration: "2 days",
    summary: "A masterclass on decision quality: framing, bias, risk and committing with clarity when information is incomplete.",
    featured: false,
  },
  {
    slug: "operational-excellence-and-execution",
    title: "Operational Excellence & Execution",
    category: "Corporate Programme",
    capability: "Operations & Execution",
    audience: "Organisations",
    format: "Custom",
    duration: "Custom",
    summary: "A corporate programme on turning strategy into reliable delivery — process discipline, performance rhythm and accountability.",
    featured: false,
  },
  {
    slug: "commercial-acumen-essentials",
    title: "Commercial Acumen Essentials",
    category: "Micro-Learning",
    capability: "Sales & Commercial Excellence",
    audience: "Young Professionals",
    format: "Self-paced",
    duration: "Self-paced",
    summary: "Short, focused modules on how businesses make money — pricing, margin, cash flow and customer value.",
    featured: false,
  },
  {
    slug: "the-vantage-strategic-leadership-certification",
    title: "The Vantage Strategic Leadership Certification",
    category: "Certification Programme",
    capability: "Leadership",
    audience: "Business Leaders",
    format: "Blended",
    duration: "12 weeks",
    summary: "The Institute's flagship certification: strategy, leadership and applied thinking, assessed through real business application.",
    featured: true,
  },
];

export const FILTER_OPTIONS = {
  capability: ["Strategy", "Leadership", "Sales & Commercial Excellence", "Business & Entrepreneurship", "Operations & Execution", "Digital & AI", "Customer", "People & Organisation"],
  audience: ["Entrepreneurs", "Founders", "Business Leaders", "Managers", "Sales Professionals", "HR / L&D Leaders", "Young Professionals", "Organisations"],
  format: ["In-person", "Cohort", "Blended", "Self-paced", "Custom"],
  duration: ["1 day", "2 days", "3 days", "4 weeks", "6 weeks", "8 weeks", "12 weeks", "Self-paced", "Custom"],
};
